var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOtpIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 164,
    height: 120,
    viewBox: "0 0 164 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.518311 111.205V31.9853C1.46002 32.5653 2.5655 32.9884 3.32979 33.7527C14.8396 45.2989 26.322 56.8769 37.7772 68.4867C38.4596 69.1691 39.0192 69.8993 39.7357 70.7114C38.8554 71.7145 38.1048 72.6016 37.3064 73.4409C29.5725 81.6297 21.8387 89.8185 14.1048 98.0073C11.4298 100.832 11.1705 103.576 13.3679 105.568C15.5652 107.561 17.9331 107.083 20.5603 104.251C27.6254 96.6174 34.6769 88.9587 41.7147 81.2749C42.9293 79.951 44.0553 78.5453 45.5293 76.8325C53.2472 85.1782 60.8627 92.4525 72.6477 92.5276C84.6033 92.6231 92.3349 85.3829 100.305 76.4367C101.322 77.9516 101.895 79.1663 102.776 80.0738C110.537 88.2353 118.332 96.3649 126.161 104.463C128.679 107.076 131.054 107.288 133.095 105.207C135.135 103.125 134.889 100.6 132.555 98.1164C128.522 93.8105 124.449 89.5455 120.402 85.2464C115.789 80.3468 111.19 75.4404 106.461 70.4043C119.017 57.6366 131.348 45.0941 143.706 32.5858C144.088 32.1968 144.818 32.1559 145.384 31.9512V111.205C142.866 117.79 138.021 120.035 131.109 120.001C92.3349 119.824 53.5611 119.824 14.7872 120.001C7.90868 120.015 2.98177 117.858 0.518311 111.205Z",
    fill: "url(#paint0_linear_1039_30904)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.0022 21.8783C7.54072 19.3193 10.6866 19.4217 13.7778 19.4217C46.078 19.4217 78.3781 19.4217 110.678 19.4217C118.082 19.4217 125.486 19.2988 132.884 19.4899C135.538 19.565 138.179 20.4112 141.57 21.0458C140.397 22.4106 139.974 22.9838 139.523 23.4819C122.031 41.3426 104.534 59.1964 87.0332 77.0433C78.667 85.5596 67.2437 85.5051 58.857 76.9614C41.465 59.26 24.1025 41.5587 6.76961 23.8573C6.18274 23.2226 5.63683 22.5812 5.0022 21.8783Z",
    fill: "url(#paint1_linear_1039_30904)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M163.482 31.5745C163.168 33.4155 162.245 35.0977 160.861 36.3513C159.31 37.6229 157.344 38.2766 155.341 38.187H110.78C98.738 38.187 86.6823 38.187 74.613 38.187C71.3921 38.187 68.8058 36.9791 67.3796 33.9902C66.863 32.878 66.5908 31.668 66.5811 30.4418C66.5061 22.874 66.5266 15.3062 66.5811 7.73839C66.5811 3.16632 69.8157 0.0204719 74.456 0C78.837 0 83.218 0 87.6058 0H155.341C158.643 0 161.216 1.24879 162.724 4.29228C163.03 5.04502 163.283 5.81797 163.482 6.60561V31.5745ZM85.2106 20.5129L85.2925 20.7381L80.5839 26.2518L84.4873 28.6334L87.2169 21.4955L89.8441 28.6334L93.8907 26.2587L88.9911 20.7176L89.0934 20.547L96.2177 21.7685V17.1964L89.1617 18.5953L89.0593 18.4111L93.8907 12.7062L89.9123 10.4339L87.251 17.5035L84.6374 10.4339L80.5908 12.7472L85.4972 18.6022L78.3798 17.2032V21.7548L85.2106 20.5129ZM109.572 18.6636L114.622 12.7062L110.623 10.4339L107.969 17.5103L105.355 10.4339L101.308 12.7472L106.215 18.6022L99.0701 17.2032V21.7548L106.249 20.4446L101.308 26.2382L105.225 28.6334L107.955 21.4955L110.582 28.6334L114.615 26.2587L109.531 20.4924L116.928 21.7685V17.2032L109.572 18.6636ZM131.307 28.6334L135.353 26.2587L130.454 20.7244L130.549 20.547L137.68 21.7685V17.2032L130.604 18.568L130.535 18.3497L135.312 12.6789L131.32 10.4066C130.44 12.7404 129.594 14.9991 128.666 17.4694L126.079 10.427L122.04 12.7472L126.762 18.3974L126.625 18.5476L119.801 17.1828V21.7344L126.625 20.4992L126.714 20.7176L121.999 26.2314L125.943 28.6334L128.673 21.5023L131.307 28.6334ZM152.399 27.4733H140.546V31.9226H152.399V27.4733Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M85.2107 20.5146L78.3867 21.7565V17.2049L85.5041 18.6038L80.5977 12.7489L84.6443 10.4355L87.2579 17.5052L89.9124 10.4355L93.9044 12.7079L89.0594 18.3991L89.1618 18.5834L96.2178 17.1845V21.7565L89.0935 20.5487L88.9912 20.7193L93.8908 26.2603L89.8442 28.6351L87.1828 21.4904L84.4532 28.6283L80.5499 26.2535L85.2585 20.7397L85.2107 20.5146Z",
    fill: "url(#paint2_linear_1039_30904)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M109.572 18.6653L116.929 17.2049V21.7702L109.531 20.4941L114.615 26.2603L110.582 28.6351L107.935 21.4836L105.205 28.6214L101.288 26.2603L106.249 20.4463L99.0703 21.736V17.2049L106.215 18.6038L101.309 12.7489L105.355 10.4355L107.969 17.512L110.623 10.4355L114.622 12.7079L109.572 18.6653Z",
    fill: "url(#paint3_linear_1039_30904)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M131.307 28.6351L128.666 21.4904L125.943 28.6351L122.04 26.2672L126.762 20.7397L126.673 20.5214L119.849 21.7565V17.2049L126.673 18.5697L126.762 18.3991L122.054 12.7557L126.093 10.4355L128.707 17.5052C129.635 15.0349 130.481 12.7762 131.361 10.4424L135.353 12.7148L130.577 18.3855L130.645 18.6038L137.721 17.239V21.8043L130.583 20.5828L130.488 20.7602L135.388 26.2945L131.307 28.6351Z",
    fill: "url(#paint4_linear_1039_30904)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M152.4 27.4746V31.9238H140.546V27.4746H152.4Z",
    fill: "url(#paint5_linear_1039_30904)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1039_30904",
    x1: 0.518311,
    y1: 75.9863,
    x2: 145.378,
    y2: 75.9863,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B2C6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#502970"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#8C2579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4237C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1039_30904",
    x1: 902.255,
    y1: 4841.79,
    x2: 28228.2,
    y2: 4841.79,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B2C6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#502970"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#8C2579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4237C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1039_30904",
    x1: 2112.55,
    y1: 532.034,
    x2: 2579.01,
    y2: 532.034,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B2C6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#502970"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#8C2579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4237C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1039_30904",
    x1: 2678.17,
    y1: 532.034,
    x2: 3145.53,
    y2: 532.034,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B2C6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#502970"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#8C2579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4237C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1039_30904",
    x1: 3244.23,
    y1: 532.034,
    x2: 3712.3,
    y2: 532.034,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B2C6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#502970"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#8C2579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4237C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1039_30904",
    x1: 2572.83,
    y1: 221.283,
    x2: 2778.72,
    y2: 221.283,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B2C6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#502970"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#8C2579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4237C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOtpIcon);
export default __webpack_public_path__ + "static/media/otp-icon.9cb8d89d99f0940e931203b73a33f9c6.svg";
export { ForwardRef as ReactComponent };